import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import SafeJSON from 'modules/core/lib/SafeJSON'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'

import { usePagination } from 'modules/shift_management/hooks/usePagination'
import { useUI } from 'modules/shift_management/hooks/useUI'
import { trackOrderEmployees } from 'modules/shift_management/lib/trackEvents'

const trackOrderEvent = (orderBy: string, orderDir: string) => {
  trackOrderEmployees(orderBy, orderDir)
}

const useOrderEmployees = () => {
  const [, dispatchPagination] = usePagination()
  const [, dispatchUI] = useUI()

  const onOrderEmployees = async (orderBy: string, orderDir: string) => {
    trackOrderEvent(orderBy, orderDir)

    dispatchPagination({ type: 'RESET_PAGINATION' })
    dispatchUI({ type: 'LOADING' })
    dispatchUI({ type: 'NOT_LOADING' })
  }
  return { onOrderEmployees }
}

const useOrderOptions = () => {
  const localStorageKeyOrderEmployeesBy = LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementBy
  const localStorageKeyOrderEmployeesDir = LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementDir

  const localStorageOrderEmployeesBy = SafeJSON.parse(
    SafeLocalStorage.getItem(localStorageKeyOrderEmployeesBy, null),
    null
  )
  const localStorageOrderEmployeesDir = SafeJSON.parse(
    SafeLocalStorage.getItem(localStorageKeyOrderEmployeesDir, null),
    null
  )

  return {
    localStorageOrderEmployeesBy,
    localStorageOrderEmployeesDir,
  }
}

export { useOrderEmployees, useOrderOptions }
